import React, { useCallback } from "react";
import { Pressable, StyleSheet } from "react-native";
import { useAtom } from "jotai";
import { transparentOverlay } from "../atoms/transparent-overlay";

const TransparentOverlayPortal = () => {
    const [hasTransparentOverlay, setHasTransparentOverlay] = useAtom(transparentOverlay);

    const onClose = useCallback(() => {
        setHasTransparentOverlay(false);
    }, [setHasTransparentOverlay]);

    if (hasTransparentOverlay) {
        return <Pressable onPress={onClose} style={styles.transparentOverlay} />;
    }
    return null;
};

const styles = StyleSheet.create({
    transparentOverlay: {
        position: "absolute",
        height: "100%",
        width: "100%",
    },
});

export default TransparentOverlayPortal;
